<div class="main-content" id="main-content">
  <section id="breadcrumbs">
    <div class="container-lg">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="br-breadcrumb">
            <ul class="crumb-list">
              <li class="crumb home">
                <a class="br-button circle" [routerLink]="['/']"
                  ><span class="sr-only">Página inicial</span
                  ><i class="fas fa-home"></i
                ></a>
              </li>
              <li class="crumb" data-active="active">
                <i class="icon fas fa-chevron-right"></i
                ><span>Envie sua sugestão de melhoria</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="page">
    <div class="container-lg">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="row" id="page-title">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h2>Ajude a melhorar o catálogo</h2>
            </div>
          </div>
          <br />
          <div id="contact-form" class="row">
            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
              <form [formGroup]="formulario" (ngSubmit)="onSubimitFormulario()">
                <div class="row">
                  <fieldset class="col-xs-12">
                    <div class="row">
                      <!-- nome -->
                      <div
                        class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      >
                        <div
                          class="br-input"
                          [ngClass]="{
                            danger:
                              formulario.get('nome').invalid &&
                              formulario.get('nome').touched
                          }"
                        >
                          <label for="txtNome">
                            Nome
                            <span class="required">*</span>
                          </label>
                          <app-required-text
                            title="Nome"
                            formControlName="nome"
                            name="nome"
                            [placeHolder]="'Nome completo'"
                            aria-describedby="danger"
                          ></app-required-text>
                        </div>
                      </div>

                      <!-- email -->
                      <div
                        class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      >
                        <div
                          class="br-input"
                          [ngClass]="{
                            danger:
                              formulario.get('email').invalid &&
                              formulario.get('email').touched
                          }"
                        >
                          <label for="txtEmail"
                            >E-mail
                            <span class="required">*</span>
                          </label>
                          <app-required-text
                            title="E-mail"
                            formControlName="email"
                            name="email"
                            [placeHolder]="'Endereço de E-mail válido'"
                            aria-describedby="danger"
                          ></app-required-text>
                        </div>
                      </div>

                      <!-- instituição -->
                      <div
                        class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      >
                        <div class="br-input">
                          <label for="txtInstituicao"
                            >Instituição/Empresa</label
                          >
                          <input
                            id="slcInstituicao"
                            type="text"
                            formControlName="instituicaoEmpresa"
                            placeholder="Informe sua instituição ou empresa"
                          />
                        </div>

                        <ng-container
                          *ngIf="
                            formulario.get('instituicaoEmpresa').errors
                              ?.maxlength
                          "
                        >
                          <span class="feedback danger" role="alert">
                            <i
                              class="fas fa-times-circle"
                              aria-hidden="true"
                            ></i>
                            A quantidade de caracteres inseridos excede o limite
                            de
                            {{
                              formulario.get('instituicaoEmpresa').errors
                                ?.maxlength.requiredLength
                            }}.
                          </span>
                        </ng-container>
                      </div>

                      <!-- sugestao -->
                      <div
                        class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      >
                        <div class="br-select">
                          <div
                            class="br-input"
                            (click)="toggleDropdown('sugestao')"
                            [ngClass]="{
                              danger:
                                formulario.get('sugestaoPara').invalid &&
                                formulario.get('sugestaoPara').touched
                            }"
                          >
                            <label for="slcSugestao"
                              >Sua sugestão é para
                              <span class="required">*</span>
                            </label>
                            <input
                              id="slcSugestao"
                              type="text"
                              placeholder="Selecione a finalidade da sua sugestão"
                              [value]="getNomeSelecionado('sugestao')"
                              readonly
                            />
                            <button
                              class="br-button"
                              type="button"
                              aria-label="Exibir lista"
                              tabindex="-1"
                              data-trigger="data-trigger"
                            >
                              <i
                                class="fas fa-angle-down"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </div>
                          <div
                            class="br-list"
                            tabindex="0"
                            [attr.expanded]="
                              isDropdownAbertoSugestao ? '' : null
                            "
                          >
                            <div
                              class="br-item"
                              tabindex="-1"
                              *ngFor="let sugestao of localAlteracao"
                              (click)="onSelecionado('sugestao', sugestao)"
                            >
                              <div class="br-radio">
                                <input
                                  id="rbSugestao{{ sugestao.id }}"
                                  type="radio"
                                  name="sugestaoPara"
                                  [value]="sugestao"
                                  [checked]="
                                    formulario.get('sugestaoPara')?.value ===
                                    sugestao
                                  "
                                  (click)="$event.stopPropagation()"
                                />
                                <label for="rbSugestao{{ sugestao.id }}">
                                  {{ sugestao }}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <ng-container
                          *ngIf="
                            !formulario.get('sugestaoPara').valid &&
                            formulario.get('sugestaoPara').touched
                          "
                        >
                          <span class="feedback danger" role="alert">
                            <i
                              class="fas fa-times-circle"
                              aria-hidden="true"
                            ></i>
                            O preenchimento desse campo é obrigatório.
                          </span>
                        </ng-container>
                      </div>

                      <!-- eixo -->
                      <div
                        *ngIf="
                          formulario.get('sugestaoPara').value === 'Curso' ||
                          formulario.get('sugestaoPara').value ===
                            'Eixo tecnológico'
                        "
                        class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      >
                        <div class="br-select">
                          <div
                            class="br-input"
                            [ngClass]="{
                              danger:
                                formulario.get('eixoTecnologicoCncstId')
                                  .invalid &&
                                formulario.get('eixoTecnologicoCncstId').touched
                            }"
                            (click)="toggleDropdown('eixo')"
                          >
                            <label for="slcEixo"
                              >Eixo Tecnológico
                              <span class="required">*</span></label
                            >
                            <input
                              id="slcEixo"
                              type="text"
                              placeholder="Filtrar por eixo tecnológico"
                              [value]="getNomeSelecionado('eixo')"
                              readonly
                            />
                            <button
                              class="br-button"
                              type="button"
                              aria-label="Exibir lista"
                              tabindex="-1"
                              data-trigger="data-trigger"
                            >
                              <i
                                class="fas fa-angle-down"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </div>

                          <div
                            class="br-list"
                            tabindex="0"
                            [attr.expanded]="isDropdownAbertoEixo ? '' : null"
                          >
                            <div
                              class="br-item"
                              tabindex="-1"
                              *ngFor="let eixo of eixos"
                              (click)="onSelecionado('eixo', eixo)"
                            >
                              <div class="br-radio">
                                <input
                                  id="rbEixoTecnologico{{ eixo.id }}"
                                  type="radio"
                                  name="eixoTecnologicoCncstId"
                                  formControlName="eixoTecnologicoCncstId"
                                  [value]="eixo.id"
                                />
                                <label for="rbEixoTecnologico{{ eixo.id }}">{{
                                  eixo.nome
                                }}</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- FIXME MENSAGEM -->
                        <ng-container
                          *ngIf="
                            !formulario.get('eixoTecnologicoCncstId').valid &&
                            formulario.get('eixoTecnologicoCncstId').touched
                          "
                        >
                          <span class="feedback danger" role="alert">
                            <i
                              class="fas fa-times-circle"
                              aria-hidden="true"
                            ></i>
                            O preenchimento desse campo é obrigatório.
                          </span>
                        </ng-container>
                      </div>

                      <!-- container de curso -->
                      <ng-container
                        *ngIf="formulario.get('sugestaoPara').value === 'Curso'"
                      >
                        <div
                          class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        >
                          <div class="br-select">
                            <div
                              class="br-input"
                              [ngClass]="{
                                danger:
                                  formulario.get('cursoCncstId').invalid &&
                                  formulario.get('cursoCncstId').touched
                              }"
                              (click)="toggleDropdown('curso')"
                            >
                              <label for="slcCurso"
                                >Curso <span class="required">*</span></label
                              >
                              <input
                                id="slcCurso"
                                type="text"
                                placeholder="Filtrar por curso"
                                [value]="getNomeSelecionado('curso')"
                                readonly
                              />
                              <button
                                class="br-button"
                                type="button"
                                aria-label="Exibir lista"
                                tabindex="-1"
                                data-trigger="data-trigger"
                              >
                                <i
                                  class="fas fa-angle-down"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </div>

                            <div
                              class="br-list"
                              tabindex="0"
                              [attr.expanded]="
                                isDropdownAbertoCurso ? '' : null
                              "
                            >
                              <div
                                class="br-item"
                                tabindex="-1"
                                *ngFor="let curso of cursos"
                                (click)="onSelecionado('curso', curso)"
                              >
                                <div class="br-radio">
                                  <input
                                    title="Curso"
                                    id="rbCurso{{ curso.id }}"
                                    type="radio"
                                    name="cursoCncstId"
                                    formControlName="cursoCncstId"
                                    [value]="curso.id"
                                  />
                                  <label for="rbCurso{{ curso.id }}">{{
                                    curso.nome
                                  }}</label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <ng-container
                            *ngIf="
                              !formulario.get('eixoTecnologicoCncstId').valid &&
                              formulario.get('eixoTecnologicoCncstId').touched
                            "
                          >
                            <span class="feedback danger" role="alert">
                              <i
                                class="fas fa-times-circle"
                                aria-hidden="true"
                              ></i>
                              O preenchimento desse campo é obrigatório.
                            </span>
                          </ng-container>
                        </div>
                      </ng-container>

                      <!-- container justificativa eixo -->
                      <ng-container
                        *ngIf="
                          formulario.get('sugestaoPara').value ===
                          'Eixo tecnológico'
                        "
                      >
                        <div
                          class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        >
                          <app-custom-form
                            [enviouForm]="enviouFormulario"
                            [display]="true"
                            (alterouValorProposta)="
                              formulario.get('propostaEixo').setValue($event)
                            "
                            (alterouValorJustificativa)="
                              formulario
                                .get('justificativaEixo')
                                .setValue($event)
                            "
                          ></app-custom-form>
                        </div>
                      </ng-container>

                      <!-- container sugestão curso -->
                      <ng-container
                        *ngIf="
                          formulario.get('cursoCncstId').dirty &&
                          formulario.get('sugestaoPara').value === 'Curso'
                        "
                      >
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <h4>
                            Selecione "Adicionar" para os itens que você deseja
                            enviar uma sugestão de melhoria.
                          </h4>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <div *ngFor="let campo of camposCurso">
                            <app-custom-form
                              [enviouForm]="enviouFormulario"
                              [label]="campo.label"
                              (alterouValorProposta)="
                                formulario
                                  .get(campo.fields.proposta)
                                  .setValue($event)
                              "
                              (alterouValorJustificativa)="
                                formulario
                                  .get(campo.fields.justificativa)
                                  .setValue($event)
                              "
                              (removeuCampo)="
                                limpaValidadores([
                                  campo.fields.proposta,
                                  campo.fields.justificativa
                                ]);
                                sub()
                              "
                              (adicionouCampo)="
                                adicionaValidadorCampoRequerido([
                                  campo.fields.proposta,
                                  campo.fields.justificativa
                                ]);
                                add()
                              "
                            ></app-custom-form>
                            <span class="br-divider my-3"></span>
                          </div>
                        </div>
                      </ng-container>

                      <!-- container de proposta de apresentação de catálogo -->
                      <ng-container
                        *ngIf="
                          formulario.get('sugestaoPara').value ===
                          'Apresentação do Catálogo (novo formato)'
                        "
                      >
                        <div
                          class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        >
                          <app-custom-form
                            [enviouForm]="enviouFormulario"
                            [display]="true"
                            (alterouValorProposta)="
                              formulario
                                .get('propostaApresentacaoCatalogo')
                                .setValue($event)
                            "
                            (alterouValorJustificativa)="
                              formulario
                                .get('justificativaApresentacaoCatalogo')
                                .setValue($event)
                            "
                          ></app-custom-form>
                        </div>
                      </ng-container>

                      <!-- Mensagem de erro -->
                      <div
                        class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      >
                        <span
                          class="feedback danger"
                          *ngIf="formulario.hasError('nenhumCampoAdicionado')"
                        >
                          <i class="fas fa-times-circle" aria-hidden="true"></i>
                          É necessário o preenchimento de ao menos um dos ítens
                          acima.
                        </span>
                      </div>

                      <!-- Termo -->
                      <div
                        class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      >
                        <h4>Autorização</h4>
                        <div class="br-checkbox">
                          <input
                            id="termo"
                            name="termo"
                            type="checkbox"
                            aria-label="Autorizo o Ministério da Educação e a equipe responsável pela atualização dos Catálogos Nacionais de Cursos a entrarem em contato comigo pelo endereço de e-mail informado neste formulário para tirar dúvidas e complementar informações."
                            formControlName="aceitaTermo"
                          />
                          <label for="termo">{{ textoTermo }}</label>

                          <span
                            class="feedback danger"
                            *ngIf="
                              formulario.get('aceitaTermo').invalid &&
                              formulario.get('aceitaTermo').touched
                            "
                          >
                            <i
                              class="fas fa-times-circle"
                              aria-hidden="true"
                            ></i>
                            É necessária a seleção deste campo para o envio das
                            sugestões.
                          </span>
                        </div>
                      </div>

                      <!-- captcha -->
                      <div
                        class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 recaptcha"
                      >
                        <re-captcha
                          formControlName="reCaptcha"
                          siteKey="6Lc8KEQkAAAAAEg1KiVIf8PRdpz5nt-oNy_H1c1k"
                        ></re-captcha>
                      </div>

                      <div
                        class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      >
                        <span
                          class="feedback danger"
                          *ngIf="
                            formulario.get('reCaptcha').invalid &&
                            (formulario.get('reCaptcha').touched ||
                              enviouFormulario)
                          "
                        >
                          <i class="fas fa-times-circle" aria-hidden="true"></i>
                          É necessário validar o reCAPTCHA para prosseguir.
                        </span>
                      </div>

                      <!-- botões -->
                      <div
                        class="form-group buttons col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      >
                        <button
                          class="br-button secondary dark-mode mr-3"
                          type="button"
                          (click)="limparFiltro()"
                        >
                          Limpar
                        </button>
                        <button
                          class="br-button primary dark-mode mr-3"
                          type="submit"
                          data-cy="btn-enviar"
                        >
                          Enviar
                        </button>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <!-- Modal de mensagem -->
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <app-popup
                    [tipoFormulario]="'sugestao'"
                    [resposta]="resposta"
                    [mostrarPopUp]="mostarPopUp"
                    (cancel)="cancelar()"
                    (enviar)="onSubimitFormulario()"
                    [erro]="erro"
                  ></app-popup>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- <app-em-breve-aviso></app-em-breve-aviso> -->
